'use client'
import MyImage from '@/shared/components/myImage'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@/shared/constants'
import React, { useState } from 'react'
import playerImg from '@/assets/images/placeholder/player.svg'
import CustomLink from '@/shared/components/customLink'
import { getSlugUrl } from '@/shared/utils'
import firstTag from '@/assets/images/first.png'
import secondTag from '@/assets/images/second.png'
import thirdTag from '@/assets/images/third.png'
import CommonNav from '@/shared/components/commonNav'

function Stats({ data }: any) {
  const tabs = [
    { navItem: 'Most Runs', value: 'mr' },
    { navItem: 'Best Strike Rate ', value: 'msr' },
    { navItem: 'Most Wickets', value: 'mw' },
    { navItem: 'Best Economy Rates', value: 'mer' }
  ]
  const [activeTab, setActiveTab] = useState<any>(tabs[0]?.value)

  const dataMap: any = {
    mr: 'statsDataBattingMostRuns',
    msr: 'statsDataBattingHighestStrikerate',
    mw: 'statsDataBowlingTopWickeTakers',
    mer: 'statsDataBowlingBestEconomy'
  }
  return (
    <>
      <div className='flex gap-4 items-center scroll-list'>
        <CommonNav
          items={tabs}
          variant='pills'
          asButton
          className='!mb-0 !font-bold justify-start !text-nowrap'
          tabClassName='!text-xs !font-medium h-9 !leading-3'
          onTabChange={(e: any) => setActiveTab(e?.value)}
          isActive={(item) => item?.value === activeTab}
        />
      </div>
      <div className=' grid md:grid-cols-2 mt-4 gap-3 md:gap-4 items-center'>
        {data[dataMap[activeTab]]?.fetchSeriesStats?.slice(0, 5).map((d: any, i: number) => {
          return (
            <div key={i} className='bg-headersActive rounded-xl overflow-hidden'>
              <div className='py-3 px-4 text-base text-textDselected border-b border-tabBorder hidden md:block'>Most Runs</div>
              <div className='py-4 md:py-5 px-4 flex items-center justify-between gap-3'>
                <div className='flex items-center gap-3 md:gap-4'>
                  <div className=' relative'>
                    {i < 3 && (
                      <div className=' absolute -left-1 -top-1'>
                        <MyImage src={i === 0 ? firstTag : i === 1 ? secondTag : i === 2 ? thirdTag : ''} height={22} width={22} />
                      </div>
                    )}
                    <MyImage
                      src={d?.oPlayer?.oImg?.sUrl ? `${S3_PREFIX}${d?.oPlayer?.oImg?.sUrl}` : playerImg}
                      alt='user'
                      blurDataURL={BLUR_DATA_URL_BASE64}
                      placeholder='blur'
                      width={60}
                      height={60}
                      className='rounded-full w-12 h-12 md:w-[60] md:h-[60]'
                    />
                  </div>
                  <div className='mt-2 border-b-white '>
                    <CustomLink href={getSlugUrl('/' + d?.oPlayer?.oSeo?.sSlug)} className='block w-full'>
                      <span className='text-sm md:text-base font-medium text-textOffWhite mb-0.5'> {d?.oPlayer?.sFullName}</span>
                    </CustomLink>
                    <span className='line-clamp-1 text-xs md:text-sm text-textDselected '> {d?.oTeam?.sAbbr}</span>
                  </div>
                </div>
                <div className='text-right'>
                  <div className='font-bold text-textOffWhite text-xl md:text-[28px]'>
                    {activeTab === 'mr'
                      ? d?.nRuns
                      : activeTab === 'mw'
                      ? d?.nWickets
                      : activeTab === 'msr'
                      ? d?.sStrike
                      : d?.nEcon}
                  </div>
                  <span className='text-sm text-textOffWhite'>{activeTab === 'mr' ? 'Runs' : activeTab === 'mw' ? 'Wickets' : activeTab === 'msr' ? 'Strike Rate' : 'Economy'}</span>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Stats
